import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@material-ui/core';
import {
  FootnoteProvider,
  LoadingProvider,
  MultipleAccountProvider,
} from 'components/layouts';
import {
  useFeatureFlags,
  FeatureFlag,
  FeatureFlags,
} from 'utils/feature-flags';
import { RoutesPath } from 'routes/constants/routes-path';
import { Header as HeaderV2 } from 'modules/dashboard/header/header';
import { GrowthPromo } from 'modules/2023-q4/growth-promo/growth-promo';
import { Footer, Header as HeaderV1 } from './components';

export const V3PortalLayout: React.FC = ({ children }) => {
  let showProductsDisclosure = false;
  const { pathname } = useLocation();
  const { isFeatureFlagEnabled } = useFeatureFlags();

  if (
    pathname === RoutesPath.pages.dashboard.path ||
    pathname === RoutesPath.pages.home.path ||
    pathname === RoutesPath.pages.onboardingComplete.path
  ) {
    showProductsDisclosure = true;
  }

  // TODO: temporary logic while we transition page by page
  const migratedPages = [
    RoutesPath.pages.connectBankAccountManual.path,
    RoutesPath.pages.connectBankAccounts.path,
    RoutesPath.pages.dashboard.path,
    RoutesPath.pages.onboardingComplete.path,
  ];

  const displayPortalLayout = (showWhiteBackgroundProp: boolean) => {
    const bankingWhiteBackground =
      isFeatureFlagEnabled(
        FeatureFlags.REACT_APP_2023_Q3_BANKING_PAGE_ENABLED,
      ) && pathname === RoutesPath.pages.banking.path;
    const showWhiteBackground =
      showWhiteBackgroundProp || bankingWhiteBackground;

    return (
      <FootnoteProvider>
        <MultipleAccountProvider>
          <FeatureFlag
            disabled={<HeaderV1 />}
            enabled={<HeaderV2 />}
            flag={FeatureFlags.REACT_APP_DASHBOARD_TREASURE_RESERVE_ENABLED}
          />

          <FeatureFlag
            enabled={<GrowthPromo />}
            flag={FeatureFlags.REACT_APP_2023_Q4_GROWTH_PROMO_ENABLED}
          />

          <LoadingProvider>
            {/* push the footer down */}
            <Box
              bgcolor={showWhiteBackground ? 'white' : ''}
              display="table"
              height="inherit"
              width="100%"
            >
              {children}
            </Box>

            <Box bgcolor={showWhiteBackground ? 'white' : ''}>
              <Footer showProductsDisclosure={showProductsDisclosure} />
            </Box>
          </LoadingProvider>
        </MultipleAccountProvider>
      </FootnoteProvider>
    );
  };

  return (
    <FeatureFlag
      disabled={displayPortalLayout(false)}
      enabled={displayPortalLayout(migratedPages.includes(pathname))}
      flag={FeatureFlags.REACT_APP_DASHBOARD_TREASURE_RESERVE_ENABLED}
    />
  );
};
